module.exports = __webpack_public_path__ + "static/media/error-visit-bg.8ab6a231.png";